<template>
  <div class="padding-left">
    <div v-for="supplier in cartBySupplierToProcess" v-bind:key="supplier.key">
      <el-row>
        <el-col :span="24" style="margin-bottom: 20px">
          <el-tag :color="getSupplierBgColor(supplier)" type="danger">{{supplier.key}}</el-tag>
        </el-col>
      </el-row>
      <el-row v-for="product in supplier.value" v-bind:key="product.id"
              type="flex"
              justify="space-between">
        <el-col :span="18"> {{product.name}}</el-col>
        <el-col :span="6">x{{product.quantity}}</el-col>
      </el-row>
      <el-divider></el-divider>
    </div>
    <el-row type="flex"
            justity="center">
      <el-col :span="12">
        <el-button type="primary" @click="lezgong()">
          Aller au panier
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import services from 'services';
  import { cssUtils } from '../../../utils/utils';

  export default {
    props: {
      cartBySupplier: {},
    },
    computed: {
      cartBySupplierToProcess() {
        return services.CartService.cartBySupplierToArray(this.cartBySupplier);
      },
    },
    methods: {
      getSupplierBgColor(supplier) {
        return cssUtils.supplierBackgroundColor(supplier);
      },
      lezgong() {
        this.$router.push({ name: 'Cart' });
      },
    },
  };
</script>

<style lang="stylus">
  .padding-left {
    padding-left 10px
  }
</style>
